import { Component, computed, effect, ElementRef, HostListener, Inject, NgZone, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { MissionControlHostService } from './mission-control-host.service';
import { updatePreset } from '@primeng/themes';
import { DOCUMENT } from '@angular/common';
import { LocalAuthService } from './auth/local-auth.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { McSettingsService } from './api/mc-settings.service';
import { UserwayService } from './services/userway.service';
import { PwaService } from './pwa.service';
import { ThemeService } from './services/theme.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class AppComponent implements OnInit {

  title = 'incident-management';

  updateDialogVisible = signal(false)
  updateDialogDismissed = signal(false)

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private host: ElementRef,
    private mcService: MissionControlHostService,
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
    private authService: LocalAuthService,
    private mcSettingsService: McSettingsService,
    private userwayService: UserwayService,
    private pwaService: PwaService,
    private themeService: ThemeService
   
  ) { 

    effect(() => {
      const currentUser = this.currentUser() 

      if (currentUser && currentUser.profileType === "staff" && this.authService.loggedIn) {

        //Temporary redirect for testing phase
        // if (!currentUser.roles.includes("head")  && !currentUser.roles.includes("it") && currentUser.newstaffId !== 943) {
        //   window.location.href = 'https://mc.ppm.org/missioncontrol/upgrade'
        // }


        //Userway settings
        this.mcSettingsService.getUserwayEnabled().subscribe(enabled => {
          if (enabled) {
            this.userwayService.embedUserwayScript()
          }
        })
      }

    })

    

    effect(() => {
      const updateAvailable = this.pwaService.updateAvailable()

      if (updateAvailable) {
        this.updateDialogVisible.set(true)
      }
    })


  }


  currentUser = toSignal(this.authService.currentUser$)
  currentExternalUser = toSignal(this.authService.currentExternalUser$)

  isAuthenticated = computed(() => {
    console.log("app isAuthenticated signal", this.currentUser())
    return this.authService.loggedIn && this.currentUser()?.profileType === "staff"
  })


  ngOnInit(): void {
    // Initialize theme service - this will load saved theme preferences
    // The theme service constructor already handles initialization

    const myWindow: any = window;

    myWindow.incidentManagement = myWindow.incidentManagement ?? {};
    myWindow.incidentManagement.navigate = this.navigate;

    const observer = new ResizeObserver(entries => {
      this.ngZone.run(() => {
        const height = entries[0].target.clientHeight;
        this.mcService.windowResize(height)
      })
  });

    observer.observe(myWindow.document.body);

    this.route.queryParamMap.subscribe(params => {
     
      const frameId = params.get("frameId")
      if (frameId && this.mcService.initialFrameId === "") {
        this.mcService.initialFrameId = frameId
      }


      const externalToken = params.get("externalToken")
      if (externalToken) {
        this.authService.setExternalToken(externalToken)
      }

    })
  


  }

  swapTheme() {
    const element = this.document.querySelector('html');
    if (element) {
      element.classList.toggle('dark-mode')
    }
    
  }

  navigate = (commands: any[]) => {
    this.ngZone.run(() => {
      this.router.navigate(commands);
    })
  }

  refreshPage() {
    window.location.reload()
  }

}
